import { render } from "./SocialComplete.vue?vue&type=template&id=3d157e5b&scoped=true"
import script from "./SocialComplete.vue?vue&type=script&lang=js"
export * from "./SocialComplete.vue?vue&type=script&lang=js"

import "./SocialComplete.vue?vue&type=style&index=0&id=3d157e5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d157e5b"]])

export default __exports__